import { render, staticRenderFns } from "./MyHomePage.vue?vue&type=template&id=2627d427&scoped=true&"
import script from "./MyHomePage.ts?vue&type=script&lang=ts&"
export * from "./MyHomePage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2627d427",
  null
  
)

export default component.exports